import gql from 'graphql-tag';

export default gql`
    mutation CreateSandTicketExport($input: GetFilteredLoadListInput) {
        createSandTicketExport(input: $input) {
            exportId
            status
        }
    }
`;
